const GLOSSARY_TERM_SELECTOR = 'span.glossary-term';

// .glossary-text rather than the whole span: a wrapper can also hold a definition span, and
// textContent would drag "[term: definition]" into the prose.
export const unwrapGlossaryTermSpan = (span: HTMLElement) => {
  const parent = span.parentNode;
  if (!parent) return;

  const word = span.querySelector('.glossary-text')?.textContent ?? span.textContent ?? '';

  parent.replaceChild(document.createTextNode(word), span);
};

// AIDEV-NOTE: PLAT-18056 — the server clears the saved bodies when a term is destroyed, but an open
// editor still holds the text it loaded, and its next save would write the stale tag back.
export const unwrapGlossaryTermSpansFor = (termId: number, root: ParentNode = document): number => {
  const spans = root.querySelectorAll<HTMLElement>(`${GLOSSARY_TERM_SELECTOR}[data-term-id="${termId}"]`);

  spans.forEach(unwrapGlossaryTermSpan);

  return spans.length;
};
